<template>
  <div v-if="false"></div>
</template>

<script>
import storeModuleGTM from '@/$plugins/store/modules/gtm'

const ALLOWED_ACTION_TYPES = Object.keys(storeModuleGTM.actions)

export default {
  name: 'GTM',
  props: {
    action: {
      type: String,
      validator: value => ALLOWED_ACTION_TYPES.includes(value)
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  created () {
    this.$store.dispatch(`gtm/${this.action}`, this.data)
  }
}
</script>
